import { useIsCommercialSuretyEnabled } from "./useIsCommercialSuretyEnabled";

export const shouldShowContractHistoryOnAccountDetail = (
	isCommercialSuretyEnabled: boolean,
	isContractSuretyAccount: boolean,
) => !isCommercialSuretyEnabled || isContractSuretyAccount;

export const useShowAccountContractHistory = (isContractSuretyAccount: boolean) => {
	const isCommercialSuretyEnabled = useIsCommercialSuretyEnabled();

	return shouldShowContractHistoryOnAccountDetail(
		isCommercialSuretyEnabled,
		isContractSuretyAccount,
	);
};
